// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__1Wlwt","title":"Images90_title__209iz","images":"Images90_images__1f6VB"};